import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { DEFAULT_ADMIN_CONFIGURATIONS } from "@constants/adminConfigurationConstants";
import { AdminConfigurations } from "types/adminConfigurationTypes";

export interface AdminConfigurationsState {
  configurations: AdminConfigurations;
  loaded: boolean;
}

const initialState: AdminConfigurationsState = {
  configurations: DEFAULT_ADMIN_CONFIGURATIONS,
  loaded: false,
};

const adminConfigurationsSlice = createSlice({
  name: "adminConfigurations",
  initialState,
  reducers: {
    fetchAdminConfigurations: (state) => state,
    setAdminConfigurations: (state, action: PayloadAction<AdminConfigurations>) => {
      state.configurations = action.payload;
      state.loaded = true;
    },
  },
});

export const { fetchAdminConfigurations, setAdminConfigurations } =
  adminConfigurationsSlice.actions;

export default adminConfigurationsSlice.reducer;
